import { DatePipe, DecimalPipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Workbook, WorkbookSheet, WorkbookSheetColumn, WorkbookSheetRow } from '@progress/kendo-angular-excel-export';
import { saveAs } from '@progress/kendo-file-saver';
import { Subject, takeUntil } from 'rxjs';
import { CLPUser, UserResponse } from '../../../../models/clpuser.model';
import { RptContractSummaryRequest, RptContractSummaryResp, RptContractSummaryResponse, TeamCodeChangeRes } from '../../../../models/cm-club-service.model';
import { eFeatures, eUserPermissions } from '../../../../models/enum.model';
import { CMClubService } from '../../../../services/cm-club.service';
import { GlobalService } from '../../../../services/global.service';
import { NotificationService } from '../../../../services/notification.service';
import { GridConfigurationService } from '../../../../services/shared/gridConfiguration.service';
import { LocalService } from '../../../../services/shared/local.service';
import { isNullOrUndefined, UtilityService } from '../../../../services/shared/utility.service';

@Component({
    selector: 'app-rpt-contractsummary',
    templateUrl: './rpt-contractsummary.component.html',
    styleUrl: './rpt-contractsummary.component.css',
    providers: [GridConfigurationService]
})
export class RptContractsummaryComponent {
    filterSummaryForm: FormGroup;
    encryptedUser: string = '';
    user: CLPUser;
    parentIndex = 0;
    nestedIndex = 0;
    sitefilter: string
    Clubfilter: string
    Repfilter: string
    Marketingfilter: string
    Planfilter: string
    Ownerfilter: string
    
    private pendingNestedIndex: number | null = null;

    showSpinner: boolean = false;
    contractSummaryFilters: RptContractSummaryResponse;
    timeFrames = [
        {
            id: 1,
            text: "This month"
        },
        {
            id: 2,
            text: "Last month"
        },
        {
            id: 3,
            text: "Calendar YTD"
        },
        {
            id: 4,
            text: "Custom"
        }
    ]
    contractSummary: RptContractSummaryResp;
    customDate: boolean = false;
    reportLoaded: boolean = false;
    columnMappings = {
        Club: {
            teamCode: 'TeamCode', club: 'Club', newContracts: 'NewContracts', initiationFee: 'Initiation Fee', membershipFee: 'Membership Fee', resNet: 'ResNet', contractTerm: 'Contract Term', avgInitiationFee: 'Avg Initiation Fee', avgMembershipFee: 'Avg Membership Fee', avgResNet: 'Avg ResNet', avgContractTerm: 'Avg Contract Term', year1Rev: 'Year 1 Rev', avgYear1Rev: 'Avg Year 1 Rev', lTV: 'LTV', avgLTV: 'Avg LTV', sOLeads: 'Leads', m2L: 'M2L', header: 'Header'
        },
        Site: {
            class1Code: 'Class1Code', site: 'Site', newContracts: 'NewContracts', initiationFee: 'Initiation Fee', membershipFee: 'Membership Fee', resNet: 'ResNet', contractTerm: 'Contract Term', avgInitiationFee: 'Avg Initiation Fee', avgMembershipFee: 'Avg Membership Fee', avgResNet: 'Avg ResNet', avgContractTerm: 'Avg Contract Term', year1Rev: 'Year 1 Rev', avgYear1Rev: 'Avg Year 1 Rev', lTV: 'LTV', avgLTV: 'Avg LTV', sOLeads: 'Leads', m2L: 'M2L', header: 'Header'
        },
        RepOnContract: {
            repOnContract: 'Rep On Contract', newContracts: 'NewContracts', initiationFee: 'Initiation Fee', membershipFee: 'Membership Fee', resNet: 'ResNet', contractTerm: 'Contract Term', avgInitiationFee: 'Avg Initiation Fee', avgMembershipFee: 'Avg Membership Fee', avgResNet: 'Avg ResNet', avgContractTerm: 'Avg Contract Term', year1Rev: 'Year 1 Rev', avgYear1Rev: 'Avg Year 1 Rev', lTV: 'LTV', avgLTV: 'Avg LTV', header: 'Header'
        },
        MarketingChannel: {
            class3Code: 'Class3Code', marketingChannel: 'Marketing Channel', newContracts: 'NewContracts', initiationFee: 'Initiation Fee', membershipFee: 'Membership Fee', resNet: 'ResNet', contractTerm: 'Contract Term', avgInitiationFee: 'Avg Initiation Fee', avgMembershipFee: 'Avg Membership Fee', avgResNet: 'Avg ResNet', avgContractTerm: 'Avg Contract Term', year1Rev: 'Year 1 Rev', avgYear1Rev: 'Avg Year 1 Rev', lTV: 'LTV', avgLTV: 'Avg LTV', sOLeads: 'Leads', m2L: 'M2L', header: 'Header'
        },
        PlanType: {
            class4Code: 'Class4Code', planType: 'Plan Type', newContracts: 'NewContracts', initiationFee: 'Initiation Fee', membershipFee: 'Membership Fee', resNet: 'ResNet', contractTerm: 'Contract Term', avgInitiationFee: 'Avg Initiation Fee', avgMembershipFee: 'Avg Membership Fee', avgResNet: 'Avg ResNet', avgContractTerm: 'Avg Contract Term', year1Rev: 'Year 1 Rev', avgYear1Rev: 'Avg Year 1 Rev', lTV: 'LTV', avgLTV: 'Avg LTV', sOLeads: 'Leads', m2L: 'M2L', header: 'Header'
        },
        ContactOwner: {
            cLPUserID: 'CLPUserID', contactOwner: 'Contact Owner', newContracts: 'NewContracts', initiationFee: 'Initiation Fee', membershipFee: 'Membership Fee', resNet: 'ResNet', contractTerm: 'Contract Term', avgInitiationFee: 'Avg Initiation Fee', avgMembershipFee: 'Avg Membership Fee', avgResNet: 'Avg ResNet', avgContractTerm: 'Avg Contract Term', year1Rev: 'Year 1 Rev', avgYear1Rev: 'Avg Year 1 Rev', lTV: 'LTV', avgLTV: 'Avg LTV', sOLeads: 'Leads', m2L: 'M2L', header: 'Header'
        },
        Contracts: {
            cMContractID: 'CMContractID', contactID: 'ContactID', cLPUserID: 'CLPUserID', teamCode: 'TeamCode', club: 'Club', class1Code: 'Class1Code', site: 'Site', class3Code: 'Class3Code', marketingChannel: 'Marketing Channel', class4Code: 'Class4Code', planType: 'Plan Type', RepOnContract: 'Rep On Contract', contractTerm: 'Contract Term', paymentBegins: 'Payment Begins', signedDate: 'Signed Date', counterSignedDate: 'Counter Signed Date', createDate: 'Create Date', initiationFee: 'Initiation Fee', membershipFee: 'Membership Fee', resNet: 'ResNet', depositAmount: 'Deposit Amount', monthsBetween: 'Months Between', year1Rev: 'Year 1 Rev', lTV: 'LTV',
        },
    };
    contractSummaryExport: RptContractSummaryResp;
    exportMsg: string = '';
    selectedCustomdtStart: string = ''
    selectedCustomdtEnd: string = ''
    currentRange = new FormGroup({
        dateStart: new FormControl<Date | null>(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
        dateEnd: new FormControl<Date | null>(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)),
    });
    private destroy$ = new Subject<void>();

    constructor(private fb: FormBuilder,
        private _utilityService: UtilityService,
        private _globalService: GlobalService,
        private router: Router,
        private _localService: LocalService,
        private datePipe: DatePipe,
        private decimalPipe: DecimalPipe,
        private cmClubService: CMClubService,
        public _gridCnfgService: GridConfigurationService) {
        this._localService.isMenu = true;
    }
    getFilteredClubSummary(pitem) {
        this.Clubfilter = pitem;
        return this.contractSummary?.clubSummary?.filter(item => item.contractTypeID == pitem);
    }
    get ClubtotalLeads(): number {
        return this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.sOLeads), 0);
    }

    get ClubtotalnewContracts(): number {
        return this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.newContracts), 0);
    }
    get Clubtotalm2L(): number {
        //return this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.m2L), 0);
        var leads = this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.sOLeads), 0)
        var Contracts = this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var TotalM2L = leads / Contracts;
        return TotalM2L;
    }

    get ClubtotalmembershipFee(): number {
        return this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.membershipFee), 0);
    }

    get ClubtotalinitiationFee(): number {
        return this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.initiationFee), 0);
    }

    get ClubtotalresNet(): number {
        return this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.resNet), 0);
    }

    get ClubtotalcontractTerm(): number {
        return this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.contractTerm), 0);
    }

    get ClubtotalavgMembershipFee(): number {
        //return this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.avgMembershipFee), 0);
        var Contracts = this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var MembershipFee = this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.membershipFee), 0);
        var AvgMembershipFee = MembershipFee / Contracts;
        return AvgMembershipFee;
    }

    get ClubtotalavgInitiationFee(): number {
        /*  return this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.avgInitiationFee), 0);*/
        var Contracts = this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var InitiationFee = this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.initiationFee), 0);
        var AvgInitiationFee = InitiationFee / Contracts;
        return AvgInitiationFee;
    }

    get ClubtotalavgContractTerm(): number {
        //return this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.avgContractTerm), 0);
        var Contracts = this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var Term = this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.contractTerm), 0);
        var AvgTerm = Term / Contracts;
        return AvgTerm;
    }

    get Clubtotalyear1Rev(): number {
        return this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.year1Rev), 0);
    }



    get ClubtotalavgYear1Rev(): number {
        //return this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.avgYear1Rev), 0);
        var Contracts = this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var Year1Rev = this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.year1Rev), 0);
        var AvgYear1Rev = Year1Rev / Contracts;
        return AvgYear1Rev;
    }

    get ClubtotallTV(): number {
        return this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.lTV), 0);
    }

    get ClubtotalavgLTV(): number {
        var ltv = this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.lTV), 0);
        var Contracts = this.contractSummary?.clubSummary.filter(item => item.contractTypeID == this.Clubfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var AvgLTv = ltv / Contracts;
        return AvgLTv;
    }











    getFilteredRepSummary(pitem) {
        this.Repfilter = pitem;
        return this.contractSummary?.repSummary?.filter(item => item.contractTypeID == pitem);
    }
    get ReptotalLeads(): number {
        return this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.sOLeads), 0);
    }

    get ReptotalnewContracts(): number {
        return this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.newContracts), 0);
    }
    get Reptotalm2L(): number {
        //return this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.m2L), 0);
        var leads = this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.sOLeads), 0)
        var Contracts = this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var TotalM2L = leads / Contracts;
        return TotalM2L;
    }

    get ReptotalmembershipFee(): number {
        return this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.membershipFee), 0);
    }

    get ReptotalinitiationFee(): number {
        return this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.initiationFee), 0);
    }

    get ReptotalresNet(): number {
        return this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.resNet), 0);
    }

    get ReptotalcontractTerm(): number {
        return this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.contractTerm), 0);
    }

    get ReptotalavgMembershipFee(): number {
        //return this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.avgMembershipFee), 0);
        var Contracts = this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var MembershipFee = this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.membershipFee), 0);
        var AvgMembershipFee = MembershipFee / Contracts;
        return AvgMembershipFee;
    }

    get ReptotalavgInitiationFee(): number {
        //return this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.avgInitiationFee), 0);
        var Contracts = this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var InitiationFee = this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.initiationFee), 0);
        var AvgInitiationFee = InitiationFee / Contracts;
        return AvgInitiationFee;
    }

    get ReptotalavgContractTerm(): number {
        //return this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.avgContractTerm), 0);
        var Contracts = this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var Term = this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.contractTerm), 0);
        var AvgTerm = Term / Contracts;
        return AvgTerm;
    }

    get Reptotalyear1Rev(): number {
        return this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.year1Rev), 0);
    }



    get ReptotalavgYear1Rev(): number {
        //return this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.avgYear1Rev), 0);
        var Contracts = this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var Year1Rev = this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.year1Rev), 0);
        var AvgYear1Rev = Year1Rev / Contracts;
        return AvgYear1Rev;
    }

    get ReptotallTV(): number {
        return this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.lTV), 0);
    }

    get ReptotalavgLTV(): number {
        //return this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.avgLTV), 0);
        var ltv = this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.lTV), 0);
        var Contracts = this.contractSummary?.repSummary.filter(item => item.contractTypeID == this.Repfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var AvgLTv = ltv / Contracts;
        return AvgLTv;
    }



    getFilteredMarketingSummary(pitem) {
        this.Marketingfilter = pitem;
        return this.contractSummary?.marketingSummary?.filter(item => item.contractTypeID == pitem);
    }

    get MarketingtotalLeads(): number {
        return this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.sOLeads), 0);
    }

    get MarketingtotalnewContracts(): number {
        return this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.newContracts), 0);
    }
    get Marketingtotalm2L(): number {
        //return this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.m2L), 0);
        var leads = this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.sOLeads), 0)
        var Contracts = this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var TotalM2L = leads / Contracts;
        return TotalM2L;
    }

    get MarketingtotalmembershipFee(): number {
        return this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.membershipFee), 0);
    }

    get MarketingtotalinitiationFee(): number {
        return this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.initiationFee), 0);
    }

    get MarketingtotalresNet(): number {
        return this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.resNet), 0);
    }

    get MarketingtotalcontractTerm(): number {
        return this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.contractTerm), 0);
    }

    get MarketingtotalavgMembershipFee(): number {
        //return this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.avgMembershipFee), 0);
        var Contracts = this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var MembershipFee = this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.membershipFee), 0);
        var AvgMembershipFee = MembershipFee / Contracts;
        return AvgMembershipFee;
    }

    get MarketingtotalavgInitiationFee(): number {
        //return this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.avgInitiationFee), 0);
        var Contracts = this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var InitiationFee = this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.initiationFee), 0);
        var AvgInitiationFee = InitiationFee / Contracts;
        return AvgInitiationFee;
    }

    get MarketingtotalavgContractTerm(): number {
        //return this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.avgContractTerm), 0);
        var Contracts = this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var Term = this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.contractTerm), 0);
        var AvgTerm = Term / Contracts;
        return AvgTerm;
    }

    get Marketingtotalyear1Rev(): number {
        return this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.year1Rev), 0);
       
    }



    get MarketingtotalavgYear1Rev(): number {
        //return this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.avgYear1Rev), 0);
        var Contracts = this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var Year1Rev = this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.year1Rev), 0);
        var AvgYear1Rev = Year1Rev / Contracts;
        return AvgYear1Rev;
    }

    get MarketingtotallTV(): number {
        return this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.lTV), 0);
    }

    get MarketingtotalavgLTV(): number {
        //return this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.avgLTV), 0);
        var ltv = this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.lTV), 0);
        var Contracts = this.contractSummary?.marketingSummary.filter(item => item.contractTypeID == this.Marketingfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var AvgLTv = ltv / Contracts;
        return AvgLTv;
    }


    getFilteredSiteSummary(pitem) {
        this.sitefilter = pitem;
        return this.contractSummary?.siteSummary?.filter(item => item.contractTypeID == pitem);
    }

    get sitetotalLeads(): number {
        return this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.sOLeads), 0);
    }
    get sitetotalContracts(): number {
        return this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.newContracts), 0);
    }

    get sitetotalM2L(): number {
        /*   return this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.m2L), 0);*/
        var leads = this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.sOLeads), 0)
        var Contracts = this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var TotalM2L = leads / Contracts;
        return TotalM2L;
    }

    get sitetotalMembershipFee(): number {
        return this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.membershipFee), 0);

    }
    get sitetotalinitiationFee(): number {
        return this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.initiationFee), 0);
    }
    get sitetotalresNet(): number {
        return this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.resNet), 0);
    }
    get sitetotalcontractTerm(): number {
        return this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.contractTerm), 0);
    }
    get sitetotalavgMembershipFee(): number {
        //return this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.avgMembershipFee), 0);

        var Contracts = this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var MembershipFee = this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.membershipFee), 0);
        var AvgMembershipFee = MembershipFee / Contracts;
        return AvgMembershipFee;

       
    }
    get sitetotalavgInitiationFee(): number {
        // return this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.avgInitiationFee), 0);
        var Contracts = this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var InitiationFee = this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.initiationFee), 0);
        var AvgInitiationFee = InitiationFee / Contracts;
        return AvgInitiationFee;
    }
    get sitetotalavgContractTerm(): number {
        //return this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.avgContractTerm), 0);
        var Contracts = this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var Term = this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.contractTerm), 0);
        var AvgTerm = Term / Contracts;
        return AvgTerm;
    }
    get sitetotalavgyear1Rev(): number {
        /*        return this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.avgYear1Rev), 0);*/
        var Contracts = this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var Year1Rev = this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.year1Rev), 0);
        var AvgYear1Rev = Year1Rev / Contracts;
        return AvgYear1Rev;
    }
    get sitetotalyear1Rev(): number {
        return this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.year1Rev), 0);
    }

    get sitetotallTV(): number {
        return this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.lTV), 0);
    }
    get sitetotalavgLTV(): number {
        //return this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.avgLTV), 0);
        var ltv = this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.lTV), 0);
        var Contracts = this.contractSummary?.siteSummary.filter(item => item.contractTypeID == this.sitefilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var AvgLTv = ltv / Contracts;
        return AvgLTv;
    }



    getFilteredPlanSummary(pitem) {
        this.Planfilter = pitem;
        return this.contractSummary?.planSummary?.filter(item => item.contractTypeID == pitem);
    }

    get PlantotalLeads(): number {
        return this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.sOLeads), 0);
    }
    get PlantotalContracts(): number {
        return this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.newContracts), 0);
    }

    get PlantotalM2L(): number {
        /*  return this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.m2L), 0);*/
        var leads = this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.sOLeads), 0)
        var Contracts = this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var TotalM2L = leads / Contracts;
        return TotalM2L;
    }

    get PlantotalMembershipFee(): number {
        return this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.membershipFee), 0);
    }
    get PlantotalinitiationFee(): number {
        return this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.initiationFee), 0);
    }
    get PlantotalresNet(): number {
        return this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.resNet), 0);
    }
    get PlantotalcontractTerm(): number {
        return this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.contractTerm), 0);
    }
    get PlantotalavgMembershipFee(): number {
        // return this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.avgMembershipFee), 0);
        var Contracts = this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var MembershipFee = this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.membershipFee), 0);
        var AvgMembershipFee = MembershipFee / Contracts;
        return AvgMembershipFee;
    }
    get PlantotalavgInitiationFee(): number {
        //return this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.avgInitiationFee), 0);
        var Contracts = this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var InitiationFee = this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.initiationFee), 0);
        var AvgInitiationFee = InitiationFee / Contracts;
        return AvgInitiationFee;
    }
    get PlantotalavgContractTerm(): number {
        //return this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.avgContractTerm), 0);
        var Contracts = this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var Term = this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.contractTerm), 0);
        var AvgTerm = Term / Contracts;
        return AvgTerm;
    }
    get Plantotalavgyear1Rev(): number {
        //return this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.avgYear1Rev), 0);
        var Contracts = this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var Year1Rev = this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.year1Rev), 0);
        var AvgYear1Rev = Year1Rev / Contracts;
        return AvgYear1Rev;
    }
    get Plantotalyear1Rev(): number {
        return this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.year1Rev), 0);
    }

    get PlantotallTV(): number {
        return this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.lTV), 0);
    }
    get PlantotalavgLTV(): number {
        //return this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.avgLTV), 0);
        var ltv = this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.lTV), 0);
        var Contracts = this.contractSummary?.planSummary.filter(item => item.contractTypeID == this.Planfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var AvgLTv = ltv / Contracts;
        return AvgLTv;
    }


    getFilteredContactOwnerSummary(pitem) {
        this.Ownerfilter = pitem;
        return this.contractSummary?.contactOwnerSummary?.filter(item => item.contractTypeID == pitem);
    }

    get OwnertotalLeads(): number {
        return this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.sOLeads), 0);
    }
    get OwnertotalContracts(): number {
        return this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.newContracts), 0);
    }

    get OwnertotalM2L(): number {
        var leads = this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.sOLeads), 0)
        var Contracts = this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var TotalM2L = leads / Contracts;
        return TotalM2L;
    }

    get OwnertotalMembershipFee(): number {
        return this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.membershipFee), 0);
    }
    get OwnertotalinitiationFee(): number {
        return this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.initiationFee), 0);
    }
    get OwnertotalresNet(): number {
        return this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.resNet), 0);
    }
    get OwnertotalcontractTerm(): number {
        return this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.contractTerm), 0);
    }
    get OwnertotalavgMembershipFee(): number {
        //return this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.avgMembershipFee), 0);
        var Contracts = this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var MembershipFee = this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.membershipFee), 0);
        var AvgMembershipFee = MembershipFee / Contracts;
        return AvgMembershipFee;
    }
    get OwnertotalavgInitiationFee(): number {
        //return this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.avgInitiationFee), 0);
        var Contracts = this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var InitiationFee = this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.initiationFee), 0);
        var AvgInitiationFee = InitiationFee / Contracts;
        return AvgInitiationFee;
    }
    get OwnertotalavgContractTerm(): number {
        // return this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.avgContractTerm), 0);
        var Contracts = this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var Term = this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.contractTerm), 0);
        var AvgTerm = Term / Contracts;
        return AvgTerm;
    }
    get Ownertotalavgyear1Rev(): number {
        
        var Contracts = this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var Year1Rev = this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.year1Rev), 0);
        var AvgYear1Rev = Year1Rev / Contracts;
        return AvgYear1Rev;
    }
    get Ownertotalyear1Rev(): number {
        return this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.year1Rev), 0);
    }

    get OwnertotallTV(): number {
        return this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.lTV), 0);
    }
    get OwnertotalavgLTV(): number {
        //return this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.avgLTV), 0);
        var ltv = this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.lTV), 0);
        var Contracts = this.contractSummary?.contactOwnerSummary.filter(item => item.contractTypeID == this.Ownerfilter).reduce((sum, item) => sum + Number(item.newContracts), 0)
        var AvgLTv = ltv / Contracts;
        return AvgLTv;
    }



    async ngOnInit() {
        this.filterSummaryForm = this.prepareFilterSummaryForm();
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(async () => {
                    if (this.user) {
                        //this.getGridConfiguration('rpt_cs_club');
                        await this.rptContractSummary_GetFilters();
                        //For User Role 2 and 1 Only (i.e) Manager and User Condition for Set Team Code only into form. 
                        if (this.user.userRole < 3) {
                            if (this.user?.teamCode > 0)
                                this.filterSummaryForm.get('teamCode').setValue(this.user?.teamCode);
                        }
                        //For User Role 1 Only (i.e) User Condition  For Set ClpUserDD into Form.
                        if (this.user.userRole == 1) {
                            this.filterSummaryForm.get('ddCLPUser').setValue(this.user?.cLPUserID);
                        }
                      
                        this.rptContractSummary_Load();
                    }
                    else {
                        this.router.navigate(['/login'])
                    }
                });
            }
            else {
                this.router.navigate(['/login'])
            }
        })
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    getGridConfiguration(gridName) {
        let columns = [
            { field: 'sOLeads', title: 'Leads', width: '80' },
            { field: 'newContracts', title: 'Contracts', width: '80' },
            { field: 'm2L', title: 'M2L', width: '80' },
            { field: 'membershipFee', title: 'Residuals', width: '80' },
            { field: 'initiationFee', title: 'Initiation', width: '80' },
            { field: 'resNet', title: 'ResNet', width: '80' },
            { field: 'contractTerm', title: 'Term', width: '80' },
            { field: 'avgMembershipFee', title: 'Avg Residual', width: '80' },
            { field: 'avgInitiationFee', title: 'Avg Initiation', width: '80' },
            { field: 'avgContractTerm', title: 'Avg Term', width: '80' },
            { field: 'year1Rev', title: 'Year 1 Rev', width: '80' },
            { field: 'avgYear1Rev', title: 'Avg Year 1 Rev', width: '80' },
            { field: 'lTV', title: 'LTV', width: '80' },
            { field: 'avgLTV', title: 'Avg LTV', width: '80' },
        ];
        let reorderColumnName: string = '';
        let sortingColumn: string = '';
        let columnWidth: string = '';
        let arrColumnWidth: any[] = [];

        switch (gridName) {
            case 'rpt_cs_club':
                columns.unshift({ field: 'club', title: 'Club', width: '150' });
                reorderColumnName = 'sOLeads,newContracts,m2L,membershipFee,initiationFee,resNet,contractTerm,avgMembershipFee,avgInitiationFee,avgContractTerm,year1Rev,avgYear1Rev,lTV,avgLTV';
                columnWidth = 'sOLeads:80,newContracts:80,m2L:80,membershipFee:80,initiationFee:80,resNet:80,contractTerm:80,avgMembershipFee:80,avgInitiationFee:80,avgContractTerm:80,year1Rev:80,avgYear1Rev:80,lTV:80,avgLTV:80';
                arrColumnWidth = ['sOLeads:80,newContracts:80,m2L:80,membershipFee:80,initiationFee:80,resNet:80,contractTerm:80,avgMembershipFee:80,avgInitiationFee:80,avgContractTerm:80,year1Rev:80,avgYear1Rev:80,lTV:80,avgLTV:80'];

                reorderColumnName = 'club,' + reorderColumnName;
                columnWidth = 'club:150,' + columnWidth;
                arrColumnWidth.push(columnWidth);
                break;
            case 'rpt_cs_site':
                reorderColumnName = 'sOLeads,newContracts,m2L,membershipFee,initiationFee,resNet,contractTerm,avgMembershipFee,avgInitiationFee,avgContractTerm,year1Rev,avgYear1Rev,lTV,avgLTV';
                columnWidth = 'sOLeads:80,newContracts:80,m2L:80,membershipFee:80,initiationFee:80,resNet:80,contractTerm:80,avgMembershipFee:80,avgInitiationFee:80,avgContractTerm:80,year1Rev:80,avgYear1Rev:80,lTV:80,avgLTV:80';
                arrColumnWidth = ['sOLeads:80,newContracts:80,m2L:80,membershipFee:80,initiationFee:80,resNet:80,contractTerm:80,avgMembershipFee:80,avgInitiationFee:80,avgContractTerm:80,year1Rev:80,avgYear1Rev:80,lTV:80,avgLTV:80'];

                columns.unshift({ field: 'site', title: 'Site', width: '150' })
                reorderColumnName = 'site,' + reorderColumnName;
                columnWidth = 'site:150,' + columnWidth;
                arrColumnWidth.push(columnWidth);
                break;
            case 'rpt_cs_reponcontract':
                columns = columns.filter(column => column.field !== 'm2L' && column.field !== 'sOLeads');
                columns.unshift({ field: 'repOnContract', title: 'Rep On Contract', width: '150' })
                reorderColumnName = 'repOnContract,newContracts,membershipFee,initiationFee,resNet,contractTerm,avgMembershipFee,avgInitiationFee,avgContractTerm,year1Rev,avgYear1Rev,lTV,avgLTV';
                columnWidth = 'repOnContract:150,newContracts:80,membershipFee:80,initiationFee:80,resNet:80,contractTerm:80,avgMembershipFee:80,avgInitiationFee:80,avgContractTerm:80,year1Rev:80,avgYear1Rev:80,lTV:80,avgLTV:80';
                arrColumnWidth = ['repOnContract:150,newContracts:80,membershipFee:80,initiationFee:80,resNet:80,contractTerm:80,avgMembershipFee:80,avgInitiationFee:80,avgContractTerm:80,year1Rev:80,avgYear1Rev:80,lTV:80,avgLTV:80'];

                break;
            case 'rpt_cs_marketingchannel':
                reorderColumnName = 'sOLeads,newContracts,m2L,membershipFee,initiationFee,resNet,contractTerm,avgMembershipFee,avgInitiationFee,avgContractTerm,year1Rev,avgYear1Rev,lTV,avgLTV';
                columnWidth = 'sOLeads:80,newContracts:80,m2L:80,membershipFee:80,initiationFee:80,resNet:80,contractTerm:80,avgMembershipFee:80,avgInitiationFee:80,avgContractTerm:80,year1Rev:80,avgYear1Rev:80,lTV:80,avgLTV:80';
                arrColumnWidth = ['sOLeads:80,newContracts:80,m2L:80,membershipFee:80,initiationFee:80,resNet:80,contractTerm:80,avgMembershipFee:80,avgInitiationFee:80,avgContractTerm:80,year1Rev:80,avgYear1Rev:80,lTV:80,avgLTV:80'];

                columns.unshift({ field: 'marketingChannel', title: 'Marketing Channel', width: '150' })
                reorderColumnName = 'marketingChannel,' + reorderColumnName;
                columnWidth = 'marketingChannel:150,' + columnWidth;
                arrColumnWidth.push(columnWidth);
                break;
            case 'rpt_cs_plantype':
                reorderColumnName = 'sOLeads,newContracts,m2L,membershipFee,initiationFee,resNet,contractTerm,avgMembershipFee,avgInitiationFee,avgContractTerm,year1Rev,avgYear1Rev,lTV,avgLTV';
                columnWidth = 'sOLeads:80,newContracts:80,m2L:80,membershipFee:80,initiationFee:80,resNet:80,contractTerm:80,avgMembershipFee:80,avgInitiationFee:80,avgContractTerm:80,year1Rev:80,avgYear1Rev:80,lTV:80,avgLTV:80';
                arrColumnWidth = ['sOLeads:80,newContracts:80,m2L:80,membershipFee:80,initiationFee:80,resNet:80,contractTerm:80,avgMembershipFee:80,avgInitiationFee:80,avgContractTerm:80,year1Rev:80,avgYear1Rev:80,lTV:80,avgLTV:80'];

                columns.unshift({ field: 'planType', title: 'Plan Type', width: '150' })
                reorderColumnName = 'planType,' + reorderColumnName;
                columnWidth = 'planType:150,' + columnWidth;
                arrColumnWidth.push(columnWidth);
                break;
            case 'rpt_cs_contactowner':
                reorderColumnName = 'sOLeads,newContracts,m2L,membershipFee,initiationFee,resNet,contractTerm,avgMembershipFee,avgInitiationFee,avgContractTerm,year1Rev,avgYear1Rev,lTV,avgLTV';
                columnWidth = 'sOLeads:80,newContracts:80,m2L:80,membershipFee:80,initiationFee:80,resNet:80,contractTerm:80,avgMembershipFee:80,avgInitiationFee:80,avgContractTerm:80,year1Rev:80,avgYear1Rev:80,lTV:80,avgLTV:80';
                arrColumnWidth = ['sOLeads:80,newContracts:80,m2L:80,membershipFee:80,initiationFee:80,resNet:80,contractTerm:80,avgMembershipFee:80,avgInitiationFee:80,avgContractTerm:80,year1Rev:80,avgYear1Rev:80,lTV:80,avgLTV:80'];

                columns.unshift({ field: 'contactOwner', title: 'Contact Owner', width: '150' })
                reorderColumnName = 'contactOwner,' + reorderColumnName;
                columnWidth = 'contactOwner:150,' + columnWidth;
                arrColumnWidth.push(columnWidth);
                break;
        }

        this._gridCnfgService.user = this.user;
        this._gridCnfgService.columns = columns;
        this._gridCnfgService.reorderColumnName = reorderColumnName;
        this._gridCnfgService.columnWidth = columnWidth;
        this._gridCnfgService.arrColumnWidth = arrColumnWidth;
        this._gridCnfgService.getGridColumnsConfiguration(this.user.cLPUserID, gridName).pipe(takeUntil(this.destroy$)).subscribe((value) => this._gridCnfgService.createGetGridColumnsConfiguration(gridName).subscribe((value) => { }));
    }


    resetGridSetting(gridName) {
        this._gridCnfgService.deleteColumnsConfiguration(this.user.cLPUserID, gridName).pipe(takeUntil(this.destroy$)).subscribe((value) => this.getGridConfiguration(gridName));
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.None)
            .then(async (result: UserResponse) => {
                if (!isNullOrUndefined(result)) {
                    const response = UtilityService.clone(result);
                    if (!isNullOrUndefined(response)) {
                        if (!isNullOrUndefined(response?.user)) {
                            this.user = UtilityService.clone(response.user);
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("activityHistory.authenticateR", err.message, null, 'Features ' + eFeatures.None);
                this._utilityService.handleErrorResponse(err);
            });
    }

    prepareFilterSummaryForm() {
        return this.fb.group({
            timeFrame: new FormControl(1),
            teamCode: new FormControl(0),
            class1Code: new FormControl(0),
            cbCorporateOwned: new FormControl(0),
            class3Code: new FormControl(0),
            class4Code: new FormControl(0),
            dateStart: new FormControl(this.datePipe.transform(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'MM/dd/yyyy')),
            dateEnd: new FormControl(this.datePipe.transform(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), 'MM/dd/yyyy')),
            ddCLPUser: new FormControl(0),
            orderBy: new FormControl('NewContracts'),
        });
    }

    onFilterSummarySubmit() {

    }



    public onTabSelect(e) {
        switch (e.title) {
            case 'Club':
                //this.getGridConfiguration('rpt_cs_club');
               
                
                break;
            case 'Site':
                //this.getGridConfiguration('rpt_cs_site');
                break;
            case 'Rep On Contract':
                //this.getGridConfiguration('rpt_cs_reponcontract');
                break;
            case 'Marketing Channel':
                //this.getGridConfiguration('rpt_cs_marketingchannel');
                break;
            case 'Plan Type':
                //this.getGridConfiguration('rpt_cs_plantype');
                break;
            case 'Contact Owner':
                //this.getGridConfiguration('rpt_cs_contactowner');
                break;
        }
    }

    async rptContractSummary_GetFilters() {
        await this.cmClubService.rptContractSummary_GetFilters(this.encryptedUser, this.user?.cLPCompanyID, this.user?.cLPUserID)
            .then(async (result: RptContractSummaryResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.contractSummaryFilters = response;
                    this.contractSummaryFilters.cMSiteClass1CodeDD?.unshift({ id: 0, text: '-Any-' })
                    this.contractSummaryFilters.ddClass3Code?.unshift({ id: 0, text: '-Any-' })
                    this.contractSummaryFilters.ddClass4Code?.unshift({ id: 0, text: '-Any-' })
                    this.contractSummaryFilters.teamsDD?.unshift({ id: 0, text: '-Any Club-' })
                    this.contractSummaryFilters.cLPUsersDD?.unshift({ id: 0, text: '-Any-' })
                    
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("liveconnect-dashboard.getCompanyData", err.message, null, 'cLPCompanyID ' + this.user?.cLPCompanyID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async rptContractSummary_Load(isLoad: boolean = true) {
        let rptContractSummaryRequest: RptContractSummaryRequest = <RptContractSummaryRequest>{};
        rptContractSummaryRequest.class1Code = +this.filterSummaryForm.controls['class1Code'].value;
        rptContractSummaryRequest.corporateOwned = +this.filterSummaryForm.controls['cbCorporateOwned'].value;
        rptContractSummaryRequest.class3Code = +this.filterSummaryForm.controls['class3Code'].value;
        rptContractSummaryRequest.class4Code = +this.filterSummaryForm.controls['class4Code'].value;
        rptContractSummaryRequest.cLPCompanyID = this.user?.cLPCompanyID;
        rptContractSummaryRequest.cLPUserID = this.filterSummaryForm.controls['ddCLPUser'].value > 0 ? +this.filterSummaryForm.controls['ddCLPUser'].value : 0;
        rptContractSummaryRequest.dateEnd = this.filterSummaryForm.controls['dateEnd'].value;
        rptContractSummaryRequest.dateStart = this.filterSummaryForm.controls['dateStart'].value;
        rptContractSummaryRequest.ddOrderBy = this.filterSummaryForm.controls['orderBy'].value;
        rptContractSummaryRequest.teamCode = +this.filterSummaryForm.controls['teamCode'].value > 0 ? this.filterSummaryForm.controls['teamCode'].value : 0;
        rptContractSummaryRequest.timeFrame = +this.filterSummaryForm.controls['timeFrame'].value;
        await this.cmClubService.rptContractSummary_Load(this.encryptedUser, rptContractSummaryRequest)
            .then(async (result: RptContractSummaryResp) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.contractSummary = response;
                    this.contractSummary.clubSummary = this.formatNumbersInObjects(this.contractSummary.clubSummary);
                    this.contractSummary.siteSummary = this.formatNumbersInObjects(this.contractSummary.siteSummary);
                    this.contractSummary.repSummary = this.formatNumbersInObjects(this.contractSummary.repSummary);
                    this.contractSummary.marketingSummary = this.formatNumbersInObjects(this.contractSummary.marketingSummary);
                    this.contractSummary.planSummary = this.formatNumbersInObjects(this.contractSummary.planSummary);
                    this.contractSummary.contactOwnerSummary = this.formatNumbersInObjects(this.contractSummary.contactOwnerSummary);
                    if (!isLoad) {
                        this.reportLoaded = true;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("liveconnect-dashboard.getCompanyData", err.message, null, 'cLPCompanyID ' + this.user?.cLPCompanyID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    onChangeTimeFrame(event) {
        if (event.target?.value == 4) {
            this.customDate = true;
        }
    }

    formatNumbersInObjects(array: any[]): any[] {
        return array?.map(obj => {
            let formattedObj: any = {};

            for (let key in obj) {
                let value = obj[key];

                if (typeof value === "string" && !isNaN(Number(value))) {
                    value = Number(value);
                }

                if (typeof value === "number") {
                    formattedObj[key] = parseFloat(value.toFixed(2));
                } else {
                    formattedObj[key] = value;
                }
            }
            return formattedObj;
        });
    }



    exportMultipleGrids() {

        if (this.contractSummaryExport?.Contracts && this.contractSummaryExport?.Contracts?.length > 0) {
            const workbook: Workbook = new Workbook({
                sheets: [
                    this.createSheet('Club', this.contractSummaryExport?.clubSummary, this.columnMappings.Club),
                    this.createSheet('Site', this.contractSummaryExport?.siteSummary, this.columnMappings.Site),
                    this.createSheet('Rep', this.contractSummaryExport?.repSummary, this.columnMappings.RepOnContract),
                    this.createSheet('Marketing Channel', this.contractSummaryExport?.marketingSummary, this.columnMappings.MarketingChannel),
                    this.createSheet('Plan Type', this.contractSummaryExport?.planSummary, this.columnMappings.PlanType),
                    this.createSheet('Contact Owner', this.contractSummaryExport?.contactOwnerSummary, this.columnMappings.ContactOwner),
                    this.createSheet('Contracts', this.contractSummaryExport?.Contracts, this.columnMappings.Contracts)
                ]
            });
            workbook.toDataURL().then((dataUrl: any) => {
                saveAs(dataUrl, 'clubcontractreport.xlsx');
            });
        }
        else {
            const workbook: Workbook = new Workbook({
                sheets: [
                    this.createSheet('Club', this.contractSummaryExport?.clubSummary, this.columnMappings.Club),
                    this.createSheet('Site', this.contractSummaryExport?.siteSummary, this.columnMappings.Site),
                    this.createSheet('Rep On Contract', this.contractSummaryExport?.repSummary, this.columnMappings.RepOnContract),
                    this.createSheet('Marketing Channel', this.contractSummaryExport?.marketingSummary, this.columnMappings.MarketingChannel),
                    this.createSheet('Plan Type', this.contractSummaryExport?.planSummary, this.columnMappings.PlanType),
                    this.createSheet('Contact Owner', this.contractSummaryExport?.contactOwnerSummary, this.columnMappings.ContactOwner)
                ]

            });
            workbook.toDataURL().then((dataUrl: any) => {
                saveAs(dataUrl, 'clubcontractreport.xlsx');
            });
        }
    }

    private createSheet(sheetName: string, data: any[], columnMapping: { [key: string]: string }): WorkbookSheet {
        if (!data || data.length === 0) {
            return {
                name: sheetName,
                rows: [{
                    cells: [{ value: "No Data Available", colSpan: 2 }]
                }]
            };
        }

        const columnKeys = Object.keys(columnMapping);
        const columns: WorkbookSheetColumn[] = columnKeys.map(() => ({
            autoWidth: true
        }));

        const headerRow: WorkbookSheetRow = {
            cells: columnKeys.map((key) => ({
                value: columnMapping[key],
                fontFamily: "Aptos Narrow"
            }))
        };

        const dataRows: WorkbookSheetRow[] = data.map((item) => ({
            cells: columnKeys.map((key) => ({
                value: item[key],
                fontFamily: "Aptos Narrow"
            }))
        }));

        return {
            name: sheetName,
            columns: columns,
            rows: [headerRow, ...dataRows]
        };
    }


    onChangeClub() {
        let teamCode = this.filterSummaryForm.controls['teamCode'].value;
        this.rptContractSummary_TeamCodeChange(teamCode);
    }

    async rptContractSummary_TeamCodeChange(teamCode: number) {
        await this.cmClubService.rptContractSummary_TeamCodeChange(this.encryptedUser, this.user?.cLPCompanyID, teamCode)
            .then(async (result: TeamCodeChangeRes) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.contractSummaryFilters.cMSiteClass1CodeDD = response?.cMSiteClass1CodeDD;
                    this.contractSummaryFilters.cLPUsersDD = response?.cLPUsersDD;
                    this.contractSummaryFilters.cMSiteClass1CodeDD?.unshift({ id: 0, text: '-Any-' })
                    this.contractSummaryFilters.cLPUsersDD?.unshift({ id: 0, text: '-Any-' })
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("liveconnect-dashboard.getCompanyData", err.message, null, 'cLPCompanyID ' + this.user?.cLPCompanyID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async rptContractSummarydExport() {
        let rptContractSummaryRequest: RptContractSummaryRequest = <RptContractSummaryRequest>{};
        rptContractSummaryRequest.class1Code = +this.filterSummaryForm.controls['class1Code'].value;
        rptContractSummaryRequest.class3Code = +this.filterSummaryForm.controls['class3Code'].value;
        rptContractSummaryRequest.class4Code = +this.filterSummaryForm.controls['class4Code'].value;
        rptContractSummaryRequest.cLPCompanyID = this.user?.cLPCompanyID;
        rptContractSummaryRequest.cLPUserID = this.filterSummaryForm.controls['ddCLPUser'].value > 0 ? +this.filterSummaryForm.controls['ddCLPUser'].value : 0;
        rptContractSummaryRequest.dateEnd = this.filterSummaryForm.controls['dateEnd'].value;
        rptContractSummaryRequest.dateStart = this.filterSummaryForm.controls['dateStart'].value;
        rptContractSummaryRequest.ddOrderBy = this.filterSummaryForm.controls['orderBy'].value;
        rptContractSummaryRequest.teamCode = +this.filterSummaryForm.controls['teamCode'].value > 0 ? this.filterSummaryForm.controls['teamCode'].value : 0;
        rptContractSummaryRequest.timeFrame = +this.filterSummaryForm.controls['timeFrame'].value;
        await this.cmClubService.rptContractSummarydExport(this.encryptedUser, rptContractSummaryRequest)
            .then(async (result: RptContractSummaryResp) => {
                if (result) {
                    this.contractSummaryExport = UtilityService.clone(result);
                    this.exportMsg = 'Your export request has been initiated and may take a few minutes to process.';
                    this.contractSummaryExport.clubSummary = this.formatNumbersInObjects(this.contractSummaryExport.clubSummary);
                    this.contractSummaryExport.siteSummary = this.formatNumbersInObjects(this.contractSummaryExport.siteSummary);
                    this.contractSummaryExport.repSummary = this.formatNumbersInObjects(this.contractSummaryExport.repSummary);
                    this.contractSummaryExport.marketingSummary = this.formatNumbersInObjects(this.contractSummaryExport.marketingSummary);
                    this.contractSummaryExport.planSummary = this.formatNumbersInObjects(this.contractSummaryExport.planSummary);
                    this.contractSummaryExport.contactOwnerSummary = this.formatNumbersInObjects(this.contractSummaryExport.contactOwnerSummary);
                    this.contractSummaryExport.Contracts.forEach((item) => {
                        if (item?.paymentBegins) {
                            item.paymentBegins = this.datePipe.transform(new Date(item?.paymentBegins), 'MM/dd/yyyy h:mm:ss a').toString();
                        }
                        if (item?.signedDate) {
                            item.signedDate = this.datePipe.transform(new Date(item?.signedDate), 'MM/dd/yyyy h:mm:ss a').toString();
                        }
                        if (item?.counterSignedDate) {
                            item.counterSignedDate = this.datePipe.transform(new Date(item?.counterSignedDate), 'MM/dd/yyyy h:mm:ss a').toString();
                        }
                        if (item?.createDate) {
                            item.createDate = this.datePipe.transform(new Date(item?.createDate), 'MM/dd/yyyy h:mm:ss a').toString();
                        }
                    })
                    this.exportMultipleGrids();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("liveconnect-dashboard.getCompanyData", err.message, null, 'cLPCompanyID ' + this.user?.cLPCompanyID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        var startDt = dateRangeStart.value;
        var endDt = dateRangeEnd.value;
        if (startDt) {
            let customdtStart = this.datePipe.transform(startDt, 'MM/dd/yyyy');
            this.filterSummaryForm.controls['dateStart'].setValue(customdtStart);

        }
        if (endDt) {
            let customdtEnd = this.datePipe.transform(endDt, 'MM/dd/yyyy');
            this.filterSummaryForm.controls['dateEnd'].setValue(customdtEnd);
        }
    }
}
